import React,{useState, useCallback} from 'react';
import { Popover, Input, Button, message } from 'antd';
import { TagsPopup } from '../VersionSettings/styles';
import { rejectDesign } from '../../../utils/services/complexDocumentsAPI';
import { VERSION_APPROVAL_PROCESS } from '../translationValues';
import {  useVersionContext } from '../../../context/complexVersionContext';
import { getTimeStampDetails } from '../../../utils/helper';
import { DESIGN_TYPE } from '../../../utils/complexDocumentConstants';

const { TextArea } = Input;

export const RejectionCommentPopup = (props) => {
  const { t, setShowRejectionPopup, documentId, currentDesign, showRejectionPopup, setShowRejectedButton, isEmail } = props;
  const [isVisible, setIsVisible] = useState(showRejectionPopup);
  const [rejectionComments, setRejectionComments] = useState('');

  const lifecycleSelector = useCallback(store => null, []);
  const [, updateVersionStore] = useVersionContext(lifecycleSelector, `ComplexDocumentName`);

  const handleVisibleChange = visibilityState => {
    setShowRejectionPopup(false);
    setIsVisible(visibilityState);
  };

  const onConfirm = async () => {
    if(rejectionComments.trim().length === 0) {
      message.error(t(
          VERSION_APPROVAL_PROCESS.REJECTION_COMMENT_MANDATORY.key,
          VERSION_APPROVAL_PROCESS.REJECTION_COMMENT_MANDATORY.value,
        ));
      return;
    }
    try {
      let templateType = currentDesign
      if(isEmail){
        templateType = currentDesign === DESIGN_TYPE.DOCUMENT ?  'email' : DESIGN_TYPE.BLOCK? 'email_block' : '';
      }
      const payload = {
        draftId: documentId,
        rejectedComments: rejectionComments,
        type: templateType
      }
      const response = await rejectDesign(payload);
      if ([5601, 5602, 5603, 5604, 5605].includes(response.statusCode)) {
        setShowRejectedButton(true);
        getTimeStampDetails(documentId, updateVersionStore, currentDesign, isEmail);
        message.success(t(
          VERSION_APPROVAL_PROCESS.REJECTION_SUCCESS.key,
          VERSION_APPROVAL_PROCESS.REJECTION_SUCCESS.value,
        ))
      }
      else {
        message.error(t(
          VERSION_APPROVAL_PROCESS.REJECTION_FAILURE.key,
          VERSION_APPROVAL_PROCESS.REJECTION_FAILURE.value,
        ))
      }
    }
    catch (e) {
      console.log(e);
    }
    finally {
      setShowRejectionPopup(false);
      setIsVisible(false);
    }
  }
  const customContent = () => {
    return(
      <TagsPopup>
      <div style={{ width: 250 }}>
          <label style={{ fontWeight: 600 }} htmlFor="rejection-comments">
            {t(
              VERSION_APPROVAL_PROCESS.REJECTION_COMMENT.key,
              VERSION_APPROVAL_PROCESS.REJECTION_COMMENT.value,
            )}
          </label>
        <TextArea
          id="rejection-comments"
          style={{marginTop:'8px', marginBottom: '8px'}}
          rows={6}
          onChange={(e) => { setRejectionComments(e.target.value) }}
          autoFocus
        />
        <div style={{float:'right'}} className='footer-btn'>
            <Button onClick={onConfirm} type="primary" style={{ background: 'black' }} >
              {t(
                VERSION_APPROVAL_PROCESS.CONFIRM_BUTTON.key,
                VERSION_APPROVAL_PROCESS.CONFIRM_BUTTON.value,
              )}          
            </Button>
        </div>
      </div>
      </TagsPopup>
    )
  }
  return(
    <TagsPopup rejection={true}>
      <Popover getPopupContainer={trigger => trigger.parentNode} style={{ width: '75%', borderRadius: '16px', outline: '1px solid grey', padding: '10px' }} overlayClassName="custom-popover" content={customContent()} visible={isVisible} trigger="click" placement="bottom" onVisibleChange={handleVisibleChange} />
    </TagsPopup>
  );
};
